import {Injectable, isDevMode} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AccountService} from '@cupoui/core/auth/account.service';
import {Account} from '@cupoui/core/user/account.model';

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService {
  constructor(
    private router: Router,
    private accountService: AccountService,

  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const authorities = route.data['authorities'];
    return this.checkLogin(authorities, state.url);
  }

  checkLogin(authorities: string[], url: string): Observable<boolean> {
    return this.accountService.identity().pipe(
      map(account => {
        if (!this.accessGranted(account)) {
          return false;
        }

        if (this.accountService.hasAnyAuthority(authorities)) {
          return true;
        }

        if (isDevMode()) {
          console.error('User has not any of required authorities:', authorities);
        }
        this.router.navigate(['accessdenied']);
        return false;
      })
    );
  }


  private accessGranted(account: Account): boolean {
    const hasOnlyCustomerRoles = account.customerRoles.length === 0;

    return !(hasOnlyCustomerRoles);
  }
}
